import { useAtomValue } from 'jotai';
import { ReactNode, useEffect } from 'react';

import { Container, Flex } from '@/lib/v2/components';

import { useStrategies } from '@/src/modules/CampaignsModule/hooks/useStrategies';

import { atomStrategyList } from '@/modules/CampaignsModule/atoms/campaignAtom';

interface CampaignMainLayoutProps {
  children: ReactNode;
}

const CampaignMainLayout = ({ children }: CampaignMainLayoutProps): JSX.Element => {
  const strategyList = useAtomValue(atomStrategyList);
  const { getStrategies } = useStrategies();

  useEffect(() => {
    strategyList.length === 0 && void getStrategies();
  }, [getStrategies, strategyList.length]);

  return (
    <Flex column>
      <div className="min-h-[calc(100vh_-_64px)] w-full bg-emblueLightGray" id="campaigns-module">
        <Container fluid="screen">{children}</Container>
      </div>
    </Flex>
  );
};

export default CampaignMainLayout;
